import * as yup from "yup";

const schema = yup
  .object({
    email: yup.string().required("Email is required").email("Invalid email"),
    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
  })
  .required();

export default schema;
